import * as React from 'react';
import createCalendarSurfaceStoreFromPrintViewSettings from './createCalendarSurfaceStoreFromPrintViewSettings';
import {
    CalendarPrintViewProps,
    CalendarPrintViewStyleProps,
    CalendarPrintViewStyles,
} from './CalendarPrintView.types';
import { CalendarSurface } from 'owa-calendar-surface-core';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import { createPrintViewConfig } from './createPrintViewConfig';
import { getPrintSurfaceStore } from './createPrintStore';

const getClassNames = classNamesFunction<CalendarPrintViewStyleProps, CalendarPrintViewStyles>();

/** The base non-styled version of CalendarPrintView. */
export function CalendarPrintViewBase<TEvent>(props: CalendarPrintViewProps<TEvent>) {
    const { styles, className, getCalendarEventColorScheme, getCharm } = props;
    const classNames = getClassNames(styles, { className: className });

    // Get the print surface store
    let store = getPrintSurfaceStore();
    createCalendarSurfaceStoreFromPrintViewSettings(props, store);

    // Determine the config for print surface components
    const config = createPrintViewConfig(store, getCalendarEventColorScheme, getCharm);

    return (
        <div className={classNames.root}>
            <CalendarSurface store={store} config={config} />
        </div>
    );
}
